import { render, staticRenderFns } from "./PolicyTimeline.vue?vue&type=template&id=6fdd1e7a"
import script from "./PolicyTimeline.vue?vue&type=script&lang=ts"
export * from "./PolicyTimeline.vue?vue&type=script&lang=ts"
import style0 from "./PolicyTimeline.vue?vue&type=style&index=0&id=6fdd1e7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports